import MuiAccordion, { AccordionProps as MuiAccordionProps } from '@mui/material/Accordion';
import * as React from 'react';

export interface AccordionProps extends MuiAccordionProps {}

export const Accordion = (props: AccordionProps) => {
  return <MuiAccordion {...props} />;
};
